import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRejectIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0.13 0 77.87 77.87",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		x: .128906,
		width: 77.8717,
		height: 77.8717,
		rx: 14.1585,
		fill: "#FA4F38"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M51.9314 22.2058L52.0907 22.3651L51.9314 22.2058L38.7955 35.3416L25.6597 22.2058C24.5927 21.1388 22.8627 21.1388 21.7957 22.2058L21.7957 22.2058C20.7286 23.2729 20.7287 25.0029 21.7957 26.0699L34.9315 39.2057L21.7957 52.3414L21.955 52.5008L21.7957 52.3414C20.7287 53.4085 20.7286 55.1384 21.7957 56.2055C22.8628 57.2725 24.5927 57.2724 25.6597 56.2055L38.7955 43.0696L51.9313 56.2055C52.9983 57.2725 54.7283 57.2725 55.7953 56.2055C56.8624 55.1384 56.8623 53.4085 55.7953 52.3415L42.6595 39.2057L55.7954 26.0698C56.8624 25.0028 56.8624 23.2729 55.7954 22.2058L55.6361 22.3651L55.7954 22.2058C54.7283 21.1388 52.9984 21.1388 51.9314 22.2058Z",
		fill: "white",
		stroke: "white",
		strokeWidth: .450636
	})]
});
export default SvgRejectIcon;
